import { useSelector } from "react-redux";
import { baseRouteMaker, routes } from "../../../constants/routeConsts";
import { userRoles } from "../../../constants";
import { Navigate, Route } from "react-router-dom";
import RequireAuth from "../../requireAuth/RequireAuth";
import userLayouts from "../../../constants/userLayoutsConsts";
import renderServiceProviderAdminProtectedRoutes from "./service-provider-admin/renderServiceProviderAdminProtectedRoutes";
import renderStaffProtectedRoutes from "./staff/renderStaffProtectedRoutes";
import { AppointmentsInfo, AppointmentsInfoDetails, Calendar, ChatRequest, CustomerInfoDetails, ServiceInfoList, ServiceProviderReviewInfo, UserChat } from "../../../component/pages/service-provider-admin";
import { ServiceProviderReviewInfoDetails } from "../../../component/pages/service-provider-admin/modules/service-provider-reviews";
const renderProtectedRoutes = (layout) => {

  switch (layout) {
    case userLayouts.IS_AUTH:
      return (
        <>
          <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN]} />}>
            {renderServiceProviderAdminProtectedRoutes({ layout })}
          </Route>

          <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]} />}>
            {renderStaffProtectedRoutes({ layout })}
          </Route>
        </>
      );
    case userLayouts.IS_MAIN:
      return (
        <>
          <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN]} />}>
            {renderServiceProviderAdminProtectedRoutes({ layout })}
          </Route>

          <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]} />}>
            {renderStaffProtectedRoutes({ layout })}
          </Route>

          <Route element={<RequireAuth allowedRoles={[userRoles.SERVICE_PROVIDER_ADMIN, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.REGULAR_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.MEDICAL_STAFF, userRoles.SERVICE_PROVIDER_ADMIN_ROLES.DOCTOR]} />}>

            {/* Appointment module routes */}
            <Route path={routes.APPOINTMENT} element={<Navigate to={baseRouteMaker(routes.CALENDAR)} replace />}/>
            <Route path={routes.CALENDAR} element={<Calendar />} />
            <Route path={routes.APPOINTMENTS_INFO} element={<AppointmentsInfo />}/>
            <Route path={routes.APPOINTMENTS_INFO_DETAILS} element={<AppointmentsInfoDetails />}/>
            <Route path={routes.SERVICE_INFO_LIST} element={<ServiceInfoList />}/>

            {/* Chat module routes */}
            <Route path={routes.CHAT} element={<Navigate to={baseRouteMaker(routes.USER_CHAT)} replace />}/>
            <Route path={routes.USER_CHAT} element={<UserChat />} />
            <Route path={routes.CHAT_REQUEST} element={<ChatRequest />} />

            {/* Customer DB details */}
            <Route path={routes.SERVICE_PROVIDER_CUSTOMER_INFO_DETAILS} element={<CustomerInfoDetails />}/>

            {/* Review info */}
            <Route path={routes.SERVICE_PROVIDER_REVIEWS} element={<Navigate to={baseRouteMaker(routes.SERVICE_PROVIDER_REVIEW_INFO)}replace/>}/>
            <Route path={routes.SERVICE_PROVIDER_REVIEW_INFO} element={<ServiceProviderReviewInfo />}/>
            <Route path={routes.SERVICE_PROVIDER_REVIEW_INFO_DETAILS} element={<ServiceProviderReviewInfoDetails />}/>

          </Route>
        </>
      );
  }
};

export default renderProtectedRoutes;
